// "Production" enabled environment

export const environment = {
    name: 'development',
    production: true,
    hmr: false,
    appConfig: 'config/appconfig.development.json',
    newRelic: {
        isEnabled: false,
    }
};
